import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { SITE, SERVICES } from '@/data/site';

export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/10 bg-[#08080C]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 pt-24 md:pt-32 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          {/* Brand block */}
          <div className="md:col-span-5">
            <div className="text-[11px] uppercase tracking-[0.28em] text-ink-muted mb-6">
              — A small studio in India
            </div>
            <p className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.05] max-w-md text-balance">
              Crafted, not <span className="italic text-violet">templated.</span>
            </p>
            <p className="mt-6 max-w-md text-ink-muted leading-relaxed">
              We partner with a handful of teams a year. If you’re here to build the next chapter of a real product, we’re here for the long form.
            </p>
            <div className="mt-8 flex flex-wrap items-center gap-3">
              <a
                href={SITE.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-cta-whatsapp"
                className="arrow-link inline-flex items-center gap-2 rounded-full border border-white/15 px-5 py-2.5 text-sm hover:bg-white/[0.04]"
              >
                Book discovery call <ArrowUpRight size={14} className="arrow" />
              </a>
              <a
                href={`mailto:${SITE.email}`}
                data-testid="footer-cta-email"
                className="text-sm text-ink-muted hover:text-white transition-colors"
              >
                {SITE.email}
              </a>
            </div>
          </div>

          {/* Services */}
          <div className="md:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.28em] text-ink-muted mb-5">Services</div>
            <ul className="space-y-2.5">
              {SERVICES.map((s) => (
                <li key={s.slug}>
                  <Link
                    to={`/services/${s.slug}`}
                    className="arrow-link inline-flex items-center gap-2 text-sm text-white/85 hover:text-white"
                  >
                    {s.title} <span className="arrow text-ink-muted">→</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div className="md:col-span-2">
            <div className="text-[11px] uppercase tracking-[0.28em] text-ink-muted mb-5">Company</div>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/work" className="text-white/85 hover:text-white">Work</Link></li>
              <li><Link to="/about" className="text-white/85 hover:text-white">About</Link></li>
              <li><Link to="/contact" className="text-white/85 hover:text-white">Contact</Link></li>
              <li><a href={`mailto:careers@niodelta.studio`} className="text-white/85 hover:text-white">Careers</a></li>
            </ul>
          </div>

          {/* Connect */}
          <div className="md:col-span-2">
            <div className="text-[11px] uppercase tracking-[0.28em] text-ink-muted mb-5">Connect</div>
            <ul className="space-y-2.5 text-sm">
              {SITE.socials.map((s) => (
                <li key={s.label}>
                  <a
                    href={s.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="arrow-link inline-flex items-center gap-2 text-white/85 hover:text-white"
                  >
                    {s.label} <span className="arrow text-ink-muted">↗</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Big watermark wordmark */}
        <div className="mt-20 md:mt-28 select-none">
          <div
            aria-hidden
            className="text-[16vw] leading-none font-black tracking-tightest text-white/[0.045]"
            style={{ letterSpacing: '-0.06em' }}
          >
            NioDelta
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col md:flex-row gap-4 md:items-center md:justify-between text-xs text-ink-muted">
          <div>© {year} NioDelta Web Studio · {SITE.location}</div>
          <div className="flex items-center gap-5">
            <a href="#" className="hover:text-white">Privacy</a>
            <a href="#" className="hover:text-white">Terms</a>
            <span>v1.0 — Ink &amp; Electric</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
